var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKml({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "382px",
    height: "512px",
    clipRule: "evenodd",
    fillRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 55.48 74.18",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m9.65 0h24.82l21.01 21.92v42.61c0 5.33-4.32 9.65-9.65 9.65h-36.18c-5.33 0-9.65-4.32-9.65-9.65v-54.88c0-5.33 4.32-9.65 9.65-9.65z",
    id: "path2",
    fillRule: "nonzero",
    fill: "#0263D1",
    style: {
      fill: "#000000",
      fillOpacity: 1
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "34.44 0 34.44 21.74 55.48 21.74",
    fill: "#fff",
    fillOpacity: 0.30196,
    id: "polygon4"
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "KML",
    transform: "matrix(0.1848839,0,0,0.17976936,2.3690488,-11.251625)",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: 96,
      lineHeight: 1.25,
      fontFamily: "Arimo",
      InkscapeFontSpecification: "'Arimo Bold'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#f8f8f8",
      fillOpacity: 1,
      stroke: "none"
    },
    id: "flowRoot821"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 87.408203,356.85719 -23.71875,-30.32812 -8.15625,6.23437 v 24.09375 H 41.705078 v -66.04687 h 13.828125 v 29.95312 l 29.765625,-29.95312 h 16.125002 l -28.218752,27.9375 30.515622,38.10937 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      lineHeight: 1.25,
      fontFamily: "Arimo",
      InkscapeFontSpecification: "'Arimo Bold'",
      fill: "#f8f8f8",
      fillOpacity: 1
    },
    id: "path829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 165.92383,356.85719 v -40.03125 q 0,-1.35937 0,-2.71875 0.0469,-1.35937 0.46875,-11.67187 -3.32813,12.60937 -4.92188,17.57812 l -11.90625,36.84375 h -9.84375 l -11.90625,-36.84375 -5.01562,-17.57812 q 0.5625,10.875 0.5625,14.39062 v 40.03125 h -12.28125 v -66.04687 h 18.51562 l 11.8125,36.9375 1.03125,3.5625 2.25,8.85937 2.95313,-10.59375 12.14062,-38.76562 h 18.42188 v 66.04687 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      lineHeight: 1.25,
      fontFamily: "Arimo",
      InkscapeFontSpecification: "'Arimo Bold'",
      fill: "#f8f8f8",
      fillOpacity: 1
    },
    id: "path831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 191.14258,356.85719 v -66.04687 h 13.82812 v 55.35937 h 35.4375 v 10.6875 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      lineHeight: 1.25,
      fontFamily: "Arimo",
      InkscapeFontSpecification: "'Arimo Bold'",
      fill: "#f8f8f8",
      fillOpacity: 1
    },
    id: "path833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKml);
export default __webpack_public_path__ + "static/media/kml.3a3f8f2b767cd6919a7b76a24980f48b.svg";
export { ForwardRef as ReactComponent };